
const API_BASE_URL = "https://backsetrag.nticdigital.com/api";
const API_MDP = "https://backsetrag.nticdigital.com";

//const API_BASE_URL = "https://localhost:8000/api";
//const API_MDP = "https://localhost:8000";


export const API = {


  
  BASE_URL: API_BASE_URL,
  MDP: API_MDP,
  LOGIN: `${API_BASE_URL}/login`,
  REGISTER: `${API_BASE_URL}/register`,
  REFRESH: `${API_BASE_URL}/token/refresh`,
};

export const HOMEAPI= {
   MDP: API_MDP,

};
